import { Injectable } from '@angular/core';
import { UserService } from 'app/Shared/Services/user.service';
import { default as _ } from 'lodash';
import { default as ExceptionColumnsJSON } from './exceptions-list-column.json';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
@Injectable(
  {providedIn: 'root'}
)
export class CaisExceptionServiceService {

  isCaisEdit: boolean = false;
  isCaisView: boolean = false;
  rowDataforDialog: any;
  exceptionDetailsColumns: any = [];

  constructor(private userService: UserService,
    private urlService: UrlsService,
    private sharedHttpClientService: SharedHttpClientService) {
    this.exceptionDetailsColumns = ExceptionColumnsJSON;
  }

  onDelete(index?: any, rowData?: any){
  return this.sharedHttpClientService.post(
      this.urlService.setAPIURl(
        APIURL.CAIS_Exception_Delete
      ), {
      CATReporterIMID: this.userService.getActiveMPID(),
      user: this.userService.getUserName(),
      userName: this.userService.getUserFirstName(),
      rowDataList:rowData
    }
    );
  }

  onRestoreDeleted(index?: any, rowData?: any){
  return this.sharedHttpClientService.post(
      this.urlService.setAPIURl(
        APIURL.CAIS_Exception_RestoreDelete
      ), {
      CATReporterIMID: this.userService.getActiveMPID(),
      user: this.userService.getUserName(),
      userName: this.userService.getUserFirstName(),
      rowDataList:rowData
    }
    );
  }
  

 }
